<div class="fixed inset-0 z-30 flex items-center justify-center bg-main-background bg-opacity-75 backdrop-blur-sm" (click)="closed.emit()">
  <div class="relative w-full max-w-xl rounded-xl bg-white shadow-xl flex flex-col max-h-[80vh]" (click)="$event.stopPropagation()">

    <!-- Loading overlay covering entire modal -->
    <div *ngIf="loading" class="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-75 rounded-xl">
      <svg class="h-8 w-8 animate-spin text-gray-200 fill-[#f25d22]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
      </svg>
    </div>

    <!-- Header -->
    <div class="flex items-start justify-between px-6 py-4 border-b border-gray-100">
      <div>
        <p class="oswald-font text-lg text-nside-gray-400">Alert Recipients</p>
        <div class="mt-1 flex items-center gap-2 flex-wrap">
          <span class="rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="alertTypeClass(alert.alertTypeId)">
            {{ alertTypeName(alert.alertTypeId) }}
          </span>
          <span class="text-xs text-gray-400">{{ (alert.dateSubmitted ? alert.dateSubmitted + 'Z' : '') | date:'MM/dd/yyyy - HH:mm' }}</span>
          <span class="text-xs text-gray-400">· {{ alert.userNameSubmitted }}</span>
        </div>
      </div>
      <button type="button" (click)="closed.emit()" class="text-gray-400 hover:text-gray-600">
        <lucide-icon [img]="icons.X" [size]="18"></lucide-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 py-4">
      <ng-container *ngIf="!loading">
        <ng-container *ngIf="recipients.length > 0; else noRecipients">
          <table class="w-full text-left text-sm">
            <thead class="oswald-font text-xs uppercase text-gray-500 bg-main-background">
              <tr>
                <th class="px-3 py-2">Name</th>
                <th class="px-3 py-2">Type</th>
                <th class="px-3 py-2">Org-Wide</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of recipients" class="border-b hover:bg-gray-50">
                <td class="px-3 py-2.5 text-xs font-medium text-gray-900 whitespace-nowrap">{{ r.displayName }}</td>
                <td class="px-3 py-2.5 text-xs text-gray-500">{{ recipientTypeLabel(r.recipientUserType) }}</td>
                <td class="px-3 py-2.5 text-xs text-gray-500">{{ r.orgWide ? 'Yes' : 'No' }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecipients>
          <p class="py-10 text-center text-sm italic text-gray-400">No recipients found for this alert.</p>
        </ng-template>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="px-6 py-3 border-t border-gray-100 flex justify-between items-center">
      <p class="text-xs text-gray-400">{{ recipients.length }} recipient{{ recipients.length !== 1 ? 's' : '' }}</p>
      <button type="button" (click)="closed.emit()"
        class="rounded-md border border-gray-300 px-4 py-1.5 text-sm text-gray-600 oswald-font hover:bg-gray-50">
        Close
      </button>
    </div>

  </div>
</div>
